import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { APP_SETTINGS, DialogService, ToastConfigService } from '@services';
import { Observable } from 'rxjs';
import { HandleError } from '../../../core/models/handle-error';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';
import { NgIf, NgStyle, NgFor, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { LoadMoreItemsPipe } from '../../../shared/pipes/load-more-items.pipe';
@Component({
    selector: 'app-videos-channels',
    templateUrl: './videos-channels.component.html',
    styleUrls: ['./videos-channels.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, FormsModule, NgStyle, NgFor, NgClass, RouterLink, SearchFilterPipe, LoadMoreItemsPipe]
})
export class VideosChannelsComponent implements OnInit {

  public screenWidth: any;
  private isSaved = true;
  public serviceError = 'Loading data. Please wait...';
  public search4channel;
  username: string;
  APP_SETTINGS :any;
  public moreItems = 10;

  public channelList: any;
  public subscribeChannels: any;

  constructor(
    private utilityService: UtilityService,
    private videoService: VideosService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService,
    private toastService: ToastConfigService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    // get channels api data
    this.spinnerService.show('bmwSpinner');
    this.videoService.getChannelsData().subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      this.channelList = data;
      this.getSubscribedChannels();
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    );

  }
  getSubscribedChannels() {
    // get subscribe channels api data
    this.videoService.getSubscribedChannels(this.username).subscribe(value => {
      this.subscribeChannels = value;
    });
  }
  isChannelSubscribed(channelNumber): boolean {
    if (this.subscribeChannels) {
      
      return this.subscribeChannels.some(channel => channel.channelNumber === channelNumber);
    }
    return false;
  }
  toggleChannelSubsciprtion(channelNumber, channelName) {
    this.analyticsService.trackChannelSubscriptionByTypeLineMake(channelNumber, channelName, this.username)
    this.isSaved = false;
    this.videoService.toggleSubscribeChannel(this.username, channelNumber).subscribe(data => {
      this.subscribeChannels = data;
      this.changeDetector.detectChanges();
    });
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (!this.isSaved) {
      if (this.dialogService.confirm('Discard changes?')['value'] === true) {
        this.applySubscriptionChanges();
        return true;
      }
      return false;
    }
    return true;
  }
  applySubscriptionChanges() {
    if (!this.isSaved) {
      this.isSaved = true;
      this.toastService.popToast('Changes Saved');
      this.utilityService.publishChannelSubscription(true);
    }
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
}
